import React from 'react';
import ReactDOM from 'react-dom/client';
// Polices auto-hébergées (la CSP interdit les polices externes) : servies
// depuis le bundle, chargées par le navigateur seulement où elles sont utilisées.
import '@fontsource-variable/manrope';
import './styles/index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
